import { Member } from './Member';
import { OnboardingAnswerForm } from './OnboardingAnswerForm';

type EnrolledMemberField =
  'firstName' |
  'lastName' |
  'companyName' |
  'companyAddressStreet' |
  'companyAddressCity' |
  'companyAddressState' |
  'companyAddressCountry' |
  'companyAddressZipCode' |
  'companyFullAddress' |
  'companyEmail' |
  'companyWebsiteUrl' |
  'companyPhoneNumber' |
  'businessMainIndustry' |
  'companyRoleId';

export type EnrolledMember = Partial<Pick<Member, EnrolledMemberField>>;

export interface EnrollmentRequest {
  memberId: string;
  member: EnrolledMember;
  forms: OnboardingAnswerForm[];
  partners: {
    partnerId: string;
    partnerMemberKey?: string;
    partnerMemberEmail?: string;
  }[];
}

const enrollmentMemberFields: Array<keyof EnrolledMember> = [
  'firstName',
  'lastName',
  'companyName',
  'companyAddressStreet',
  'companyAddressCity',
  'companyAddressState',
  'companyAddressCountry',
  'companyAddressZipCode',
  'companyFullAddress',
  'companyEmail',
  'companyWebsiteUrl',
  'companyPhoneNumber',
  'businessMainIndustry',
  'companyRoleId',
];

export function toEnrolledMember(member: Partial<Member>): EnrolledMember {
  return enrollmentMemberFields.reduce<EnrolledMember>((payload, field) => {
    if (member[field] !== null && member[field] !== undefined) {
      return {
        ...payload,
        [field]: member[field],
      };
    }
    return payload;
  }, {});
}

export function filterNullFields<T extends object>(object: T): Partial<T> {
  return Object.fromEntries(
    Object.entries(object).filter(([_, value]) => value !== null),
  ) as Partial<T>;
}
